<style lang="sass" scoped>
.tab
  position: relative
  display: flex
  justify-content: center
  align-items: center
  padding: 0 20px
  flex: 1
  font-size: 14px
  font-weight: 500
  cursor: pointer

  .icon
    margin-right: 6px
    color: var(--menu-primary-background-colour) !important

.tabs_box
  display: flex
  padding-left: 30px
  height: 48px
  background: #fff
  border-bottom: 1px solid rgba(51, 68, 85, .1)
  cursor: pointer

  .tab
    color: rgba(51, 68, 85, .7)
    text-transform: uppercase

    &.active
      color: #fff

    .tab_line
      position: absolute
      bottom: -1px
      width: 100%
      height: 2px
      background: var(--menu-primary-background-colour)

.tabs_blok_box
  display: flex
  height: 36px
  background: #fff
  cursor: pointer

  .tab
    border: 1px solid var(--menu-primary-background-colour)
    color: var(--menu-primary-background-colour)
    cursor: pointer

    &:first-child
      border-radius: 4px 0 0 4px

    &:last-child
      flex: 1
      border-radius: 0 4px 4px 0

    &.active
      color: #fff
      background-color: var(--menu-primary-background-colour)

      .icon
        color: #fff !important
</style>

<template lang="pug">
  div(:class="[blok ? 'tabs_blok_box' : 'tabs_box']")
    .tab(
      v-for="(item, index) in titleList"
      :key="index"
      :class="{'active': active === index}"
      :style="{width: width, padding: width ? '0' : ''}"
      @click="activeTab(index)"
    )
      icon.icon(v-if='iconList && iconList.length') {{ iconList[index] }}
      | {{ item }}
      .tab_line(v-if="active === index")
</template>

<script>
export default {
  model: {
    prop: 'active',
    event: 'onChange'
  },

  props: {
    titleList: {
      type: Array
    },

    iconList: {
      type: Array
    },

    active: {
      type: Number,
      default: 0
    },

    blok: {
      type: Boolean,
      default: false
    },

    width: {
      type: String
    }
  },

  methods: {
    activeTab(index) {
      this.$emit('onChange', index)
    }
  }
}
</script>
